var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{on:{"click":_vm.onBack}},[_vm._v("Вернуться к проекту")])}
var staticRenderFns = []

export { render, staticRenderFns }